module.exports = __webpack_public_path__ + "static/media/wms-bg.70160b57.jpg";